import { render } from "./onboarding_handoff.html?vue&type=template&id=4da625d2&external"
import script from "./onboarding_handoff.js?vue&type=script&lang=js&external"
export * from "./onboarding_handoff.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__